module.exports = "assets/img/tour_des_finances.jpg";